import React from 'react'
import classNames from 'classnames'
import cls from './rounded-button.module.scss'
import { Link } from 'react-router-dom'

const VARIATIONS = {
  OUTLINE: cls.outline,
  PLAIN: cls.plain,
  ICON: cls.icon,
  DARK: cls.dark,
  LIGHT: cls.light,
}

const RoundedButton = props => {
  const {
    variant = 'LIGHT',
    className,
    loading = false,
    disabled = false,
    onClick,
    tabIndex,
    children,
    ...restProps
  } = props
  const isDisabled = disabled || loading

  let Container = 'button'

  if (restProps.to) {
    Container = Link
  }

  return (
    <Container
      {...restProps}
      disabled={restProps.to ? undefined : isDisabled}
      aria-disabled={isDisabled || undefined}
      aria-busy={loading || undefined}
      tabIndex={restProps.to && isDisabled ? -1 : tabIndex}
      onClick={event => {
        if (isDisabled) {
          event.preventDefault()
          return
        }
        onClick && onClick(event)
      }}
      className={classNames(cls.button, VARIATIONS[variant], className, {
        [cls.loading]: loading,
      })}
    >
      {children}
    </Container>
  )
}

export default RoundedButton
